import { ReactComponent as ArrowRightIcon } from "assets/images/iconsV2/arrow-right.svg";
import { ReactComponent as DoorIcon } from "assets/images/iconsV2/door.svg";
import { ReactComponent as PortIcon } from "assets/images/iconsV2/port.svg";

type SvgComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

const SERVICE_TYPE_ICON_MAP: Record<string, [SvgComponent, SvgComponent]> = {
  dtd: [DoorIcon, DoorIcon],
  dtp: [DoorIcon, PortIcon],
  ptd: [PortIcon, DoorIcon],
  ptp: [PortIcon, PortIcon],
};

export function getServiceRequirementIcons(
  serviceType: string,
): { origin: SvgComponent; arrow: typeof ArrowRightIcon; destination: SvgComponent } | null {
  const icons = SERVICE_TYPE_ICON_MAP[serviceType.toLowerCase()];
  if (!icons) return null;

  const [origin, destination] = icons;
  return { origin, arrow: ArrowRightIcon, destination };
}
